import React, { Component } from 'react';
import img from '../images/service1.png'; 
import img2 from '../images/service2.png';
import img3 from '../images/service3.png';
import img4 from '../images/service4.png';

class Services extends Component {
    render() {
        return (
            <div id="services" className="bg-gray-100 py-12">
                <section data-aos="zoom-in-down">
                    <div className="my-4 py-4">
                        <h2 className="my-2 text-center text-3xl text-red-700 uppercase font-bold">Services</h2>
                        
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-red-700'></div>
                        </div>
                        <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-gray-500">
                            Nous sommes profondément engagés dans la croissance et le succès de nos clients.
                        </h2>
                    </div>

                    <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-300 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <img alt="card img" className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out" src={img} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Vente simplifiée</h2>
                                    <p className="text-md font-medium">
                                        Mettez vos produits en ligne en quelques clics et atteignez un large public. 
                                        Nous vous accompagnons dans la gestion de vos annonces pour maximiser vos ventes.
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-300 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <img alt="card img" className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out" src={img2} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Livraison rapide</h2>
                                    <p className="text-md font-medium">
                                        Bénéficiez de nos partenaires logistiques pour une livraison rapide et fiable de vos commandes, où que vous soyez.
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-300 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <img alt="card img" className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out" src={img3} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Catalogue varié</h2>
                                    <p className="text-md font-medium">
                                        Explorez une large gamme de produits dans différentes catégories, soigneusement sélectionnés pour répondre à tous vos besoins.
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-300 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <img alt="card img" className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out" src={img4} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Communauté active</h2>
                                    <p className="text-md font-medium">
                                        Rejoignez une communauté dynamique de vendeurs et d’acheteurs, et accédez à des conseils et des astuces pour tirer le meilleur parti de votre expérience.
                                    </p>
                                </div>
                            </div>                    
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Services;
